import './main.css';

import { AppView } from './AppView';
import { FlashView } from './FlashView';
import { hydrate } from './params';
import { registerSW } from 'virtual:pwa-register'
import { currentTheme, toggleTheme } from './theme';
import { initPullToRefresh } from './pullToRefresh';

const intervalMS = 10 * 60 * 1000; // 10 minutes

const root = document.querySelector('#forecast');
const flash = FlashView(document.querySelector('#messages'));
const app = AppView(root, flash);

const moonIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
const sunIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="5"/><path d="M12 1v3M12 20v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M1 12h3M20 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/></svg>';

const themeToggle = document.querySelector<HTMLButtonElement>('#theme-toggle');
function renderThemeToggle() {
  if (themeToggle) {
    themeToggle.innerHTML = currentTheme() === 'dark' ? sunIcon : moonIcon;
  }
}
renderThemeToggle();
themeToggle?.addEventListener('click', () => {
  toggleTheme();
  renderThemeToggle();
  app.reload(); // the radar image URL is theme-specific, not just the CSS
});

const pullRefreshIndicator = document.querySelector<HTMLElement>('#pull-refresh');
if (pullRefreshIndicator) {
  initPullToRefresh(pullRefreshIndicator, () => app.reload());
}

window.addEventListener('error', async (err) => {
  const { message, stack } = err.error;
  console.error(err.error);

  await fetch('_error', {
    method: 'POST',
    body: JSON.stringify({
      message,
      stack
    })
  });
});

registerSW({
  immediate: true,
  onRegistered(r) {
    r && setInterval(() => {
      r.update()
      console.log('re-fetching in background');
      app.reload();
    }, intervalMS)
  }
})

window.addEventListener('load', async () => {
  try {
    hydrate();
    document.body.classList.add('loading');
    await app.reload();
  } catch(e) {
    root.classList.add('error');
    flash.displayAlert(e, 'error');
    throw e;
  } finally {
    document.body.classList.remove('loading');
    document.body.classList.remove('installing');
  }
});
